import { Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import NewElementButton from '../../../components/NewElementButton';
import ReportsCards from '../../../components/Reports/ReportsCards';
import SearchBar from '../../../components/SearchBar';
import Spinner from '../../../components/Spinner';
import { FilterListByName } from '../../../constants/filterListByName';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const defaultReports = [];

const ReportsPage = () => {
  const fetch = useFetch();
  const { accountId, domainId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [reports, setReports] = useState(defaultReports);
  const [allReports, setAllReports] = useState(defaultReports);
  const [error, setError] = useState();

  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/exports`;

  useEffect(() => {
    setReports(undefined);
    setAllReports(undefined);
    fetch(fetchUrl)
      .then(({ reports }) => {
        setReports(reports);
        setAllReports(reports);
      })
      .catch((error) => {
        setError(error);
      });
  }, [fetchUrl, fetch]);

  const searchHandler = (term) => {
    if (term === '') {
      setReports(allReports);
    } else {
      setReports(FilterListByName(term, allReports));
    }
  };

  const toggleReport = (reportIndex, running) => {
    const report = reports[reportIndex];
    fetch(`${fetchUrl}/${report.id}`, {
      method: 'PUT',
      body: JSON.stringify({ running }),
    })
      .then(({ report }) => {
        const updatedReports = [...reports];
        updatedReports[reportIndex] = report;
        setReports(updatedReports);
      })
      .catch((e) => setError(e));
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!reports) {
    return <Spinner />;
  }

  const reportElements = <ReportsCards reports={reports} toggleReport={toggleReport} />;

  return (
    <div>
      <Metadata title={`${Page['reports']}`} />
      <Grid>
        <Grid.Col span={12} ta="right" mb="md">
          <NewElementButton
            restrictionKey="reportsCreate"
            onClick={() => navigate(location.pathname + '/new' + location.search)}
            title="New Export"
          />
        </Grid.Col>
      </Grid>
      <SearchBar onChange={(event) => searchHandler(event.target.value)} />
      {reportElements}
    </div>
  );
};

export default ReportsPage;
